<div class="modal-body" ngbAutofocus>
  <myp-inline-loader [loading]="loading" height="300px" spinnerName="simpleSignupLoader"></myp-inline-loader>
  @if (!loading) {
    <div class="row">
      @if (!success) {
        <div class="col-md-12 m-b-20">
          <fui-heading level="5" textAlign="center" text="ONE LOGIN FOR ALL."></fui-heading>
          <div class="d-flex align-items-center justify-content-center m-t-20">
            <myp-svg id="fender-logo" class="svg-neutral" width="100" height="30"></myp-svg>
            <div class="m-x-20">&bull;</div>
            <myp-svg id="presonus-logo" class="svg-neutral" width="100" height="30"></myp-svg>
          </div>
          <br />
          <br />

          @if (userService.user.fender_cognito_user_id) {
            <p>
              {{ "link_accounts.presonus_password" | translate }}
            </p>
          } @else {
            <p>
              {{ "link_accounts.we_found_account" | translate: { email: user.email } }}
            </p>
            <p>
              {{ "link_accounts.create_password" | translate }}
            </p>
          }

          @if (loginMethod != "cognito") {
            <p>
              {{ "link_accounts.social_login_note1" | translate: { loginMethod: loginMethod | sentenceCase } }}
              <br />
              <br />
              {{ "link_accounts.social_login_note2" | translate: { loginMethod: loginMethod | sentenceCase } }}
              <button class="btn btn-secondary btn-sm" (click)="logout()">{{ "link_accounts.click_to_logout" | translate }}</button>
            </p>
          }
          <div class="form-group col-md-12">
            <label class="control-label">{{ "general.password" | translate }}</label>
            <input [type]="passwordVisible ? 'text' : 'password'" (keyup.enter)="submit()" (keyup)="errorMessage = ''" class="form-control" [(ngModel)]="password" />
            <div class="text-muted">
              {{ "profile.password_min" | translate }}
            </div>
          </div>
          <div class="col-md-12 m-b-20">
            <myp-switch [active]="passwordVisible" label="Show password" [labelToRight]="true" (toggle)="passwordVisible = !passwordVisible"></myp-switch>
          </div>
          @if (errorMessage) {
            <div class="col-md-12 text-center">
              <div class="api-error-message">{{ errorMessage }}</div>
            </div>
          }
          <div class="col-md-12 m-t-20">
            <button type="button" class="btn btn-primary m-r-10" (click)="submit()">{{ "general.submit" | translate }}</button>
            <button type="button" class="btn btn-blank m-l-10" (click)="activeModal.close('Close click')">{{ "com.onboarding.do_this_later" | translate }}</button>
          </div>
        </div>
      }
      @if (success) {
        <div class="col-md-12 m-b-20 text-center">
          <div class="d-flex justify-content-center">
            <myp-svg id="fender-logo" class="svg-brand-color" width="200" height="100"></myp-svg>
          </div>
          <br />
          <fui-heading level="5" textAlign="center" text="SUCCESS!"></fui-heading>
          <p>{{ "link_accounts.link_success" | translate }}</p>
          <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
        </div>
      }
    </div>
    <div class="m-t-50">
      <span class="text-muted t-12" [innerHTML]="'login.terms_privacy_agree' | translate"></span>
    </div>
  }
</div>
<!-- <div class="modal-footer" *ngIf="!loading">
<button type="button" class="btn btn-primary" *ngIf="loginMethod == 'cognito' && !userAlreadyMigrated" (click)="submit()">Log In</button>
<button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
</div> -->
